let searchSlider = $('.searchSlider-init');
owlSearchSlider = searchSlider.owlCarousel({
    loop: true,
    margin: 10,
    dots: false,
    animateOut: 'fadeOut',
    items: 1,
    lazyLoad: true,
    nav: false,
});

$('.searchSlider-button button.owl-next').click(function () {
    searchSlider.trigger('next.owl.carousel');
});

$('.searchSlider-button button.owl-prev').click(function () {
    searchSlider.trigger('next.owl.carousel');
});

if ($('.searchSlider-init.owl-carousel .item').length < 2) {
    owlSearchSlider.data('owl.carousel').options.loop = false;
    owlSearchSlider.trigger('refresh.owl.carousel');
}


$(window).scroll(function () {
    // fixedSearchMain();
});

function fixedSearchMain() {
    if ($("div").is('.searchSlider-input')) {
        var st = $(window).scrollTop();

        element = $('.searchSlider-input input');

        var w = $(window).width();

        show_start = element.offset().top + element.innerHeight() - st - 50;

        show_end = element.offset().top - st - 80;

        if (show_start <= 0) {
            $('.headerSearchPc .headerSearch-form').addClass('active');
            if (w < 992 && w >= 768) {
                $('.headerLogo svg g.sing').css('display', 'none');
            }
        } else {
            $('.headerSearchPc .headerSearch-form').removeClass('active');
            if (w < 992 && w >= 768) {
                $('.headerLogo svg g.sing').css('display', 'block');
            }
        }
    }
    return true;
}

/* Прократка надписи
var step = -1;

$('#_SearchSlider').on('mousewheel', function (event) {

    var stop_step = -79;
    var width = $(window).width();

    if (width < 1200) {
        stop_step = -30;
    } else if (width < 1600) {
        stop_step = -46;
    } else if (width < 1900) {
        stop_step = -73;
    } else if (width < 768) {
        stop_step = -1;
    }

    if (event) {
        if (step >= stop_step) {
            event.preventDefault();
            if (event.deltaY <= -1) {
                step = step - 10;
                $('.searchSlider-moveText').css('left', step + '%');
            } else if (event.deltaY >= 1) {
                if (step < -10) step = step + 10;
                $('.searchSlider-moveText').css('left', step + '%');
            }
        } else  {
            if ($(window).scrollTop() < 10 && event.deltaY) {
                if (event.deltaY >= 1) {
                    if (step < -10) step = step + 10;
                    $('.searchSlider-moveText').css('left', step + '%');
                }
            }

        }
    }
});
*/
